(function () {
    if (window.top && window.top.om) {
        const button = document.querySelector("div.c-header-meine-allianz__actions.js-login-section > button");
        if (button) {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                window.top.om.azde.requestLogin(window.top.location);
            })
        }
    }
})()
